var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":"Điều khoản vận chuyển"}},[_c('embed',{attrs:{"src":"/privacy/dieu-khoan-van-chuyen.pdf","type":"application/pdf","frameBorder":"0","scrolling":"auto","height":"700","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }